const PAYMENT_LINKS = {
  // Tournament Registration
  member: 'https://buy.stripe.com/6oE9Dhg0fe6dew8000',
  non_member: 'https://buy.stripe.com/6oE9Dhg0fe6dew8000',
  member_late: 'https://buy.stripe.com/3csdTxg0f1jrds4fZ2',
  non_member_late: 'https://buy.stripe.com/3csdTxg0f1jrds4fZ2',
  
  // Membership
  student_membership: 'https://buy.stripe.com/6oE6r53dt6DL9bOeUV',
  single_membership: 'https://buy.stripe.com/5kA7v915l5zHafS8wy',
  family_membership: 'https://buy.stripe.com/dR65n1dS70fn2NqcMP',
  
  // Late Membership
  student_membership_late: 'https://buy.stripe.com/5kA16L15l2nv73G28d',
  single_membership_late: 'https://buy.stripe.com/4gw02HbJZaU11Jm3ci',
  family_membership_late: 'https://buy.stripe.com/cN24iX8xNgelafSeV1'
};

export default PAYMENT_LINKS;